import type { Rule } from "antd/es/form";
import moment from "moment-jalaali";
import type { DateObject } from "react-multi-date-picker";

export function GetFullMediaPath(
  path: string,
  width: number | undefined = undefined,
) {
  if (width) {
    return import.meta.env.VITE_PUBLIC_MEDIA_URL + `/resizer/${width}/` + path;
  } else {
    return import.meta.env.VITE_PUBLIC_MEDIA_URL + "media/" + path;
  }
}
export function numberFormatter(number: number) {
  return number.toLocaleString("fa-IR");
}
export function numberFormatterLabel(number: number) {
  return `${number.toLocaleString("fa-IR")} ریال`;
}

export const onRemove = (
  imageId: string,
  setFile: React.Dispatch<
    React.SetStateAction<
      {
        file: File | undefined;
        id: string;
        fileUrl: string;
      }[]
    >
  >,
) => {
  setFile((prev) => prev.filter((e) => e.id !== imageId));
};

export const requireRules = (title: string): Rule[] => {
  return [{ required: true, message: `${title} اجباری است ` }];
};

export const formatSizeUnits = (bytes: string) => {
  if (+bytes >= 1073741824) {
    bytes = (+bytes / 1073741824).toFixed(2) + " GB";
  } else if (+bytes >= 1048576) {
    bytes = (+bytes / 1048576).toFixed(2) + " MB";
  } else if (+bytes >= 1024) {
    bytes = (+bytes / 1024).toFixed(2) + " KB";
  } else if (+bytes > 1) {
    bytes = bytes + " bytes";
  } else if (+bytes == 1) {
    bytes = bytes + " byte";
  } else {
    bytes = "0 bytes";
  }
  return bytes;
};

export const formatDate = (date?: string) => {
  if (!date) return "-";

  const d = new Date(date);
  if (isNaN(d.getTime())) return "-";

  return new Intl.DateTimeFormat("fa-IR-u-ca-persian", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(d);
};

export const formatForSend = (date: DateObject | string) => {
  if (!date) return null;

  if (typeof date === "string") {
    return moment(date, "jYYYY/jMM/jDD").locale("fa").format("YYYY-MM-DD");
  }

  return moment(date.toDate()).locale("fa").format("YYYY-MM-DD");
};

export const filterDate = (
  startDate: string,
  endDate: string,
  created: string,
) => {
  if (!startDate && !endDate) return true;
  const startTime = startDate
    ? moment(startDate, "jYYYY-jMM-jDD HH:mm").toDate().getTime()
    : -Infinity;
  const endTime = endDate
    ? moment(endDate, "jYYYY-jMM-jDD HH:mm").toDate().getTime()
    : Infinity;
  const recordTime = new Date(created).getTime();
  if (recordTime >= startTime && recordTime <= endTime) {
    return true;
  } else {
    return false;
  }
};

export const logoutMethod = async (token: string) => {
  return await fetch(
    `${import.meta.env.VITE_PUBLIC_API_ADDRESS}api/v1/auth/logout/`,
    {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      method: "POST",
      body: JSON.stringify({ last_data: {} }),
    },
  )
    .then((res) => res.json())
    .then((data) => {
      return data;
    });
};
